(function () {
  'use strict';

  var ATTRIBUTE_IDS = [
    'product_category_title_custom',
    'product_sub_title_card_custom',
    'product_variant_ids'
  ];
  var EXCLUDED_CATEGORY_IDS = [
    'all-products', 'best-solutions', 'new-arrivals', 'freedom-sale', 'app_top_10',
    'fathers-day', 'customer-favourites', 'popular-products', 'recommendations',
    'offers', 'app_new_product', 'exclusive', 'frontpage'
  ];
  var layoutFrame;
  var LAYOUT_KEY = 'wizzyKrishnaProductLayout';

  function compact(values) {
    var out = [];
    var list = Array.isArray(values) ? values : [];
    for (var i = 0; i < list.length; i++) {
      var value = list[i];
      if (Array.isArray(value)) {
        var nested = compact(value);
        for (var j = 0; j < nested.length; j++) out.push(nested[j]);
        continue;
      }
      if (value === null || value === undefined || value === '') continue;
      value = String(value);
      if (out.indexOf(value) === -1) out.push(value);
    }
    return out;
  }

  function attributeValues(product, attributeId) {
    var values = Array.isArray(product[attributeId]) ? product[attributeId] : [];
    var attribute = Array.isArray(product.attributes)
      ? product.attributes.find(function (item) { return item.id === attributeId; })
      : null;

    if (attribute && Array.isArray(attribute.values)) {
      attribute.values.forEach(function (item) {
        if (item && Array.isArray(item.value)) values = values.concat(item.value);
      });
    }

    return compact(values);
  }

  function first(value) {
    return Array.isArray(value) ? value[0] : value;
  }

  function productVariantIds(product) {
    var ids = attributeValues(product, 'product_variant_ids');

    if (ids.length) return ids;

    (product.attributes || [])
      .filter(function (attribute) { return attribute.id === 'product_variant_prices'; })
      .forEach(function (attribute) {
        (attribute.values || []).forEach(function (item) {
          if (item && item.variationId) ids.push(item.variationId);
        });
      });

    return compact(ids);
  }

  function number(value) {
    return Number(String(first(value) || 0).replace(/,/g, ''));
  }

  function plainText(value) {
    return String(first(value) || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').replace(/\s+([,.!?;:])/g, '$1').trim();
  }

  function absoluteUrl(value) {
    try {
      return new URL(value, window.location.origin).href;
    } catch (error) {
      return value || '';
    }
  }

  function htmlAttribute(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function labelData(product, variantIds, sellingPrice, comparePrice, inStock) {
    var settings = window.wizzyKrishnaSettings || {};
    var isBestseller = (product.categories || []).some(function (category) {
      return category && category.id === 'best-solutions';
    });
    var collections = isBestseller && settings.bestsellerCollectionId
      ? '||' + settings.bestsellerCollectionId + '||'
      : '||';
    var variants = [];

    (product.attributes || [])
      .filter(function (attribute) { return attribute.id === 'product_variant_prices'; })
      .forEach(function (attribute) {
        (attribute.values || []).forEach(function (variant) {
          variants.push({ id: variant.variationId, price: first(variant.value), inStock: variant.inStock !== false });
        });
      });

    if (!variants.length) variants.push({ id: variantIds[0] || product.id, price: sellingPrice, inStock: inStock });

    return htmlAttribute(JSON.stringify(variants.map(function (variant) {
      return {
        variant_id: Number(variant.id),
        product_id: Number(product.groupId || product.id),
        available: variant.inStock,
        title: product.name || '',
        compare_at_price: Math.round(number(comparePrice) * 100),
        price: Math.round(number(variant.price) * 100),
        price_with_currency: product.priceWithCurrency || variant.price,
        sale_amount: '',
        collections: collections,
        inventory_management: '',
        qty: -1,
        container: 'card',
        can_show_preorder: false,
        diff_day_create: 0,
        diff_day_publish: 0
      };
    })));
  }

  function decorateProduct(product) {
    var variantIds = productVariantIds(product);
    var sellingPrice = first(product.sellingPrice || product.finalPrice || product.price) || '';
    var comparePrice = first(product.price) || '';
    var inStock = product.inStock !== false && product.inStock !== 'false';

    product.krishnaProductId = product.groupId || product.singleVarientGroupId || product.id;
    product.krishnaVariantId = variantIds[0] || product.id;
    product.krishnaSingleVariant = variantIds.length <= 1;
    product.krishnaMultipleVariants = variantIds.length > 1;
    var category = (product.categories || []).find(function (item) {
      return item && !EXCLUDED_CATEGORY_IDS.includes(item.id);
    });

    product.krishnaCategoryTitle = attributeValues(product, 'product_category_title_custom')[0] || (category && category.name) || product.subTitle || '';
    product.krishnaCardSubtitle = attributeValues(product, 'product_sub_title_card_custom')[0] || '';
    product.krishnaDescription = plainText(product.description || product.productDescription || product.shortDescription);
    product.krishnaSellingPrice = String(sellingPrice).replace(/\.00$/, '');
    product.krishnaComparePrice = String(comparePrice).replace(/\.00$/, '');
    product.krishnaRawSellingPrice = number(sellingPrice);
    product.krishnaHasComparePrice = number(comparePrice) > number(sellingPrice);
    product.krishnaSoldOut = !inStock;
    product.krishnaAvailability = inStock ? 'InStock' : 'OutOfStock';
    product.krishnaAbsoluteUrl = absoluteUrl(product.url);
    product.krishnaLabelData = labelData(product, variantIds, sellingPrice, comparePrice, inStock);

    return product;
  }

  function decorateProducts(products) {
    if (!products) return products;
    if (!Array.isArray(products) && Array.isArray(products.products)) products = products.products;
    if (!Array.isArray(products)) return products;
    while (products.length === 1 && Array.isArray(products[0])) products = products[0];
    products.forEach(function (product) {
      if (!product || product.isBanner) return;
      decorateProduct(product);
    });
    return products;
  }

  function syncAutocompleteTop() {
    if (layoutFrame) return;
    layoutFrame = window.requestAnimationFrame(function () {
      layoutFrame = null;
      var popup = document.getElementById('FormSearch');
      var input = document.querySelector('.wizzy-search-input:focus') || document.querySelector('.wizzy-search-input');
      var anchor = input || popup;
      var rect = anchor ? anchor.getBoundingClientRect() : (input && input.getBoundingClientRect());

      if (rect && rect.bottom > 0) {
        document.documentElement.style.setProperty('--wizzy-krishna-autocomplete-top', Math.round(rect.bottom) + 'px');
        document.documentElement.style.setProperty('--wizzy-krishna-autocomplete-left', Math.max(0, Math.round(rect.left)) + 'px');
        document.documentElement.style.setProperty('--wizzy-krishna-autocomplete-right', Math.max(0, Math.round(window.innerWidth - rect.right)) + 'px');
      }
    });
  }

  function moveAutocompleteHost() {
    var host = document.querySelector('.wizzy-body-end-wrapper');
    var headerSearch = document.querySelector('.header-search');
    if (host && headerSearch && host.parentNode !== headerSearch) headerSearch.appendChild(host);
  }

  function disableNativePredictiveSearch() {
    var input = document.getElementById('search-in-modal');
    var scopes = input && input._x_dataStack;
    var nativeSearch = Array.isArray(scopes) && scopes.find(function (scope) {
      return scope && typeof scope.getSearchResult === 'function';
    });

    if (!nativeSearch || nativeSearch.wizzyDisabled) return;
    nativeSearch.wizzyDisabled = true;
    nativeSearch.result = '';
    nativeSearch.openResults = false;
    nativeSearch.showSuggest = false;
    nativeSearch.getSearchResult = function () {
      this.result = '';
      this.openResults = false;
      this.showSuggest = false;
    };
  }

  function normalizeLayout(layout) {
    return layout === 'list' ? 'list' : 'grid';
  }

  function savedLayout() {
    try {
      return normalizeLayout(window.localStorage.getItem(LAYOUT_KEY));
    } catch (error) {
      return 'grid';
    }
  }

  function applyTileLayout(layout, save) {
    layout = normalizeLayout(layout);
    var wrapper = document.querySelector('.wizzy-search-wrapper');
    if (!wrapper) return;

    wrapper.classList.toggle('list-layout', layout === 'list');
    wrapper.setAttribute('data-wizzy-layout', layout);
    document.querySelectorAll('[data-wizzy-layout]').forEach(function (button) {
      if (button.matches('button')) button.setAttribute('aria-pressed', button.dataset.wizzyLayout === layout ? 'true' : 'false');
    });

    if (save) {
      try { window.localStorage.setItem(LAYOUT_KEY, layout); } catch (error) {}
    }
  }

  function handleTileLayout(event) {
    var button = event.target.closest && event.target.closest('.wizzy-krishna-tile-button');
    if (!button) return;
    event.preventDefault();
    applyTileLayout(button.dataset.wizzyLayout, true);
  }


  function bindFacetReset() {
        const resetButtons = document.querySelectorAll('.wizzy-facet-reset');
    
        resetButtons.forEach(button => {
            button.addEventListener('click', function() {
                const facetBlock = this.closest('.wizzy-filters-facet-block');
                
                if (facetBlock) {
                    const activeItems = facetBlock.querySelectorAll('.wizzy-facet-list-item.active');
                    
                    activeItems.forEach(item => {
                        item.click();
                    });
                    
                    const searchInput = facetBlock.querySelector('.facet-head-search-input');
                    if (searchInput) {
                        searchInput.value = '';
                    }
                }
            });
        });
  }

  function syncOverlayState() {
    var autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
    var isOpen = !!(autocomplete && autocomplete.style.display !== 'none');

    if (document.documentElement.classList) {
      document.documentElement.classList.toggle('wizzy-krishna-autocomplete-open', isOpen);
    }
    syncAutocompleteTop();
  }

  function syncSortExpanded() {
    if (!window.getComputedStyle) return;
    var selector = document.querySelector('.wizzy-common-select-selector');
    var options = document.querySelector('.wizzy-common-select-options');
    if (selector && options) selector.setAttribute('aria-expanded', window.getComputedStyle(options).display === 'block' ? 'true' : 'false');
  }

  function isMobileSearchLayout() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function placeMobileSort() {
    var wrapper = document.querySelector('.wizzy-search-wrapper');
    if (!wrapper) return;

    var mobileSlot = wrapper.querySelector('.wizzy-krishna-mobile-sort');
    var desktopSlot = wrapper.querySelector('.search-filters-top-wrapper');
    var desktopSort = desktopSlot && desktopSlot.querySelector('.wizzy-search-sort-wrapper');
    var mobileSort = mobileSlot && mobileSlot.querySelector('.wizzy-search-sort-wrapper');
    var sort = desktopSort || mobileSort;
    if (!sort) return;

    if (isMobileSearchLayout() && mobileSlot) {
      if (desktopSort && mobileSort && desktopSort !== mobileSort) mobileSlot.removeChild(mobileSort);
      if (sort.parentNode !== mobileSlot) mobileSlot.appendChild(sort);
      return;
    }

    if (!desktopSlot) return;
    if (mobileSort && desktopSort && desktopSort !== mobileSort) mobileSlot.removeChild(mobileSort);
    else if (sort.parentNode !== desktopSlot) desktopSlot.appendChild(sort);
  }

  function observeWizzyOverlays() {
    if (!window.MutationObserver || !document.body) return;
    new window.MutationObserver(function () {
      moveAutocompleteHost();
      disableNativePredictiveSearch();
      syncOverlayState();
      syncSortExpanded();
      placeMobileSort();
      applyTileLayout(savedLayout());
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });
  }

  function replaySearchFocus() {
    if (window.location.pathname === '/pages/search') return;
    window.setTimeout(function () {
      var input = document.querySelector('#FormSearch .wizzy-search-input');
      var form = document.getElementById('FormSearch');
      if (input && form && !form.classList.contains('popup-hidden')) {
        input.focus();
        input.click();
      }
    }, 150);
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest && event.target.closest('#SearchOpen, [data-search-open]');
    if (!open) return;
    window.setTimeout(function () {
      var root = open.closest('.header-search') || document;
      var input = root.querySelector('.wizzy-search-input') || document.querySelector('#search-in-modal, #search-in-modal-mobile');
      if (!input) return;
      input.focus();
      input.click();
    }, 500);
  }, true);

  function applyConfig(config) {
    if (!config) return config;
    config.common = config.common || {};
    config.common.lazyDOMConfig = config.common.lazyDOMConfig || {};
    config.common.templateAttributes = compact((config.common.templateAttributes || []).concat(ATTRIBUTE_IDS));
    config.common.templateSettings = Object.assign({}, config.common.templateSettings || {}, window.wizzyKrishnaSettings || {});
    config.common.lazyDOMConfig.identifiersToClickOnSearch = ['#SearchClose'];
    config.filters = config.filters || { configs: {} };
    config.filters.configs = config.filters.configs || {};
    config.filters.configs.layout = 'v1';
    config.filters.configs.keepOpenedInDesktopAfterApply = true;
    config.filters.configs.keepOpenedInMobileAfterApply = true;

    if (config.autocomplete && config.autocomplete.configs && config.autocomplete.configs.defaultBehaviour) {
      var defaultSuggestions = config.autocomplete.configs.defaultBehaviour.suggestions;
      if (defaultSuggestions) defaultSuggestions.displayRecent = true;
    }

    if (config.search && config.search.configs) {
      config.search.configs.facets = config.search.configs.facets || {};
      config.search.configs.facets.leftFacets = config.search.configs.facets.leftFacets || {};
      config.search.configs.facets.leftFacets.collapsible = true;
      config.search.configs.facets.leftFacets.mobileCollapsible = true;
      config.search.configs.noProductsFound = config.search.configs.noProductsFound || {};
      config.search.configs.noProductsFound.showProducts = true;
      config.search.configs.noProductsFound.defaultPool = {
        method: 'filters',
        expiry: 'session',
        data: { productsCount: 8, categories: ['best-solutions'] }
      };
      if (config.search.view && config.search.view.templates && config.search.view.templates.literals) {
        config.search.view.templates.literals.emptySearchResultPageSubTitle = 'Checkout our Bestsellers';
      }
    }
    if (config.search && config.search.configs && config.search.configs.pagination) {
      config.search.configs.pagination.appendInExistingList = true;
    }
    return config;
  }

  function init() {
    var config = window.wizzyConfig;
    var events = config && config.events;
    if (!config || !events || init.done) return;

    try {
      applyConfig(config);

      events.registerEvent(events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, decorateProducts, 100);
      events.registerEvent(events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER, function (data) {
        if (data && data.products) decorateProducts(data.products);
        return data;
      }, 100);
      events.registerEvent(events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (data) {
        if (data) data.withDescription = true;
        return data;
      }, 100);
      events.registerEvent(events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function (data) {
        syncAutocompleteTop();
        return data;
      }, 100);
      if (events.allowedEvents.BEFORE_INIT) {
        events.registerEvent(events.allowedEvents.BEFORE_INIT, applyConfig, 100);
      }
      if (events.allowedEvents.BEFORE_LAZY_INIT) {
        events.registerEvent(events.allowedEvents.BEFORE_LAZY_INIT, applyConfig, 100);
      }

      window.addEventListener('resize', function () {
        syncAutocompleteTop();
        placeMobileSort();
      }, { passive: true });
      window.addEventListener('scroll', syncAutocompleteTop, { passive: true, capture: true });
      document.addEventListener('click', handleTileLayout);
      var closeButton = document.getElementById('SearchClose');
      if (closeButton) closeButton.setAttribute('aria-label', 'Close search');
      moveAutocompleteHost();
      disableNativePredictiveSearch();
      observeWizzyOverlays();
      syncOverlayState();
      syncSortExpanded();
      placeMobileSort();
      applyTileLayout(savedLayout());
      replaySearchFocus();
      events.registerEvent(events.allowedEvents.VIEW_RENDERED, function (data) {
        placeMobileSort();
        bindFacetReset();
        return data;
      }, 100);
      events.registerEvent(events.allowedEvents.PRODUCTS_RESULTS_RENDERED, placeMobileSort, 100);
      init.done = true;
    } catch (error) {
      console.error('[wizzy-krishna] init', error);
    }
  }

  window.wizzyKrishnaTest = {
    decorateProduct: decorateProduct,
    normalizeLayout: normalizeLayout
  };

  var previousOnWizzyScriptLoaded = window.onWizzyScriptLoaded;
  window.onWizzyScriptLoaded = function () {
    if (typeof previousOnWizzyScriptLoaded === 'function') previousOnWizzyScriptLoaded();
    init();
  };
  window.onWizzyLoaded = Array.isArray(window.onWizzyLoaded) ? window.onWizzyLoaded : [];
  window.onWizzyLoaded.push(init);
  if (window.wizzyScriptLoaded) init();
})();
